export default "__VITE_ASSET__Cdn23Xhj__"